export default __webpack_public_path__ + "static/media/overflow-indicator.7869997c.svg";